import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  Button,
  Navbar,
  Nav,
  Image,
} from "react-bootstrap";
import { useHistory } from "react-router";
import { Path } from "../../static/Constants";
import web3 from "../Service/web3";
import { networkID } from "../../static/utils";
import { BellDot, User, Ticket, Dices, Pickaxe, Rocket, ChevronDown, Menu, X } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { colors } from "../../theme/colors";
import { typography } from "../../theme/typography";
import Notification from "./notification/Notification";
import { CommonDropdown, CommonDropdownItem } from "./CommonDropdown/CommonDropdown";
import { CommonButton } from "./ui";
import { initNavbarScrollAnimation, animateNavHover, animateNavLeave } from "./home/animations";
import { gsap } from "gsap";

const NavBar = () => {
  const [user, setUser] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [expandedMobileDropdown, setExpandedMobileDropdown] = useState(null);
  
  const [notifications, setNotifications] = useState([]);
  const navbarRef = useRef(null);
  const logoImageRef = useRef(null);
  const logoTextRef = useRef(null);
  const mobileMenuTl = useRef(null);
  
  let history = useHistory();
  const apiUrl = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    if (window.ethereum) {
      window.web3 = web3;
      window.ethereum.on("accountsChanged", () => {
        getuser();
      });
      getuser();
    }
  }, []);

  const getuser = async () => {
    let account = await web3.eth.getAccounts();
    if (account.length !== 0) {
      setUser(account[0]);
    }
  };

  const handleConnectWallet = () => {
    if (window.ethereum) {
      window.ethereum.enable();

      web3.eth.net.getId().then((netId) => {
        if (netId == networkID) {
        } else {
          setIsModalOpen(true);
          setModalMessage(`Please Connect to Main net (Network Id ${networkID})`);
        }
      });
    } else {
      setIsModalOpen(true);
      setModalMessage(
        "Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!"
      );
    }
  };



  // Handles the sticky navbar shrink/grow effect on scroll using GSAP
  useEffect(() => {
    return initNavbarScrollAnimation(navbarRef, logoImageRef, logoTextRef);
  }, []);

  const fetchData = async () => {
    try {
      const getNotificationsFromLocalStorage = () => {
        const savedNotifications = localStorage.getItem("notifications");
        if (savedNotifications) {
          setNotifications(JSON.parse(savedNotifications));
        }
      };
      let account = await web3.eth.getAccounts();
      const response = await fetch(`${apiUrl}/notifications?limit=5&skip=0`, {
        method: "GET",
        headers: {
          Authorization: account[0],
        },
      });
      if (response.ok) {
        const data = await response.json();
        setNotifications(data);
        localStorage.setItem("notifications", JSON.stringify(data));
      } else {
        console.error("Error fetching notifications:", response.statusText);
        getNotificationsFromLocalStorage();
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    const fetchWSData = async () => {
      try {
        let account = await web3.eth.getAccounts();
        let ws = new WebSocket(`${apiUrl}/ws`);
        ws.onopen = () => {
          ws.send(JSON.stringify({ id: account[0] }));
          ws.onmessage = (e) => {
            let resp = JSON.parse(e.data);
            const storedWSNotifications =
              localStorage.getItem("wsnotifications") || "[]";
            const wsnotifications = JSON.parse(storedWSNotifications);
            if (!wsnotifications.includes(resp.title)) {
              wsnotifications.push(resp.title);
              localStorage.setItem(
                "wsnotifications",
                JSON.stringify(wsnotifications)
              );
              toast.success(resp.title, {
                position: "top-right",
                hideProgressBar: false,
                onClose: () => {
                  const updatedWSNotifications = wsnotifications.filter(
                    (item) => item !== resp.title
                  );
                  localStorage.setItem(
                    "wsnotifications",
                    JSON.stringify(updatedWSNotifications)
                  );
                },
              });
            }
          };
        };
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchWSData();
  }, []);
  const underlineRef = useRef(null);

  const handleNavHover = (e) => {
    animateNavHover(underlineRef, e.currentTarget);
  };

  const handleNavLeave = () => {
    animateNavLeave(underlineRef);
  };

  const animateBgIn = (e) => {
    if (window.innerWidth >= 768) return;
    const bg = e.currentTarget.querySelector('.mobile-hover-bg');
    if (bg) {
      gsap.to(bg, { width: '100%', opacity: 1, duration: 1.2, ease: 'power3.out', overwrite: 'auto' });
    }
    const text = e.currentTarget.querySelector('.nav-link-content');
    if (text) {
      gsap.to(text, { color: '#ffffff', letterSpacing: '0.15em', duration: 1.2, ease: 'power3.out', overwrite: 'auto' });
    }
    const subItems = e.currentTarget.querySelectorAll('.mobile-lottery-item');
    if (subItems.length > 0) {
      gsap.to(subItems, { color: '#ffffff', duration: 1.2, ease: 'power3.out', overwrite: 'auto' });
    }
  };

  const animateBgOut = (e) => {
    if (window.innerWidth >= 768) return;
    const bg = e.currentTarget.querySelector('.mobile-hover-bg');
    if (bg) {
      gsap.to(bg, { width: '0%', opacity: 0, duration: 1.25, ease: 'elastic.out', overwrite: 'auto' });
    }
    const text = e.currentTarget.querySelector('.nav-link-content');
    if (text) {
      gsap.to(text, { color: '#ffffff', letterSpacing: '0.05em', duration: 1.25, ease: 'elastic.out', overwrite: 'auto' });
    }
    const subItems = e.currentTarget.querySelectorAll('.mobile-lottery-item');
    if (subItems.length > 0) {
      gsap.to(subItems, { color: 'rgba(255, 255, 255, 0.75)', duration: 1.25, ease: 'elastic.out', overwrite: 'auto' });
    }
  };

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    const handleScrollLock = () => {
      if (isMobileMenuOpen && window.innerWidth < 768) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };

    handleScrollLock();
    window.addEventListener('resize', handleScrollLock);

    return () => {
      window.removeEventListener('resize', handleScrollLock);
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [isMobileMenuOpen]);

  // Reset mobile navbar state when crossing the desktop/mobile breakpoint
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
        setExpandedMobileDropdown(null);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Re-initialize GSAP Mobile Menu Animation on breakpoint change
  useEffect(() => {
    const setupMobileAnimation = () => {
      if (window.innerWidth >= 768) {
        // Desktop: make sure mobile GSAP styles do not remain applied.
        gsap.set(".navbarcollapse", {
          clearProps: "opacity,visibility",
        });

        gsap.set(".mobile-nav-item", {
          clearProps: "opacity,transform",
        });

        mobileMenuTl.current?.kill();
        mobileMenuTl.current = null;

        return;
      }

      // Mobile: create the menu timeline.
      const ctx = gsap.context(() => {
        gsap.set(".navbarcollapse", {
          autoAlpha: 0,
        });

        gsap.set(".mobile-nav-item", {
          opacity: 0,
          y: -18,
        });

        mobileMenuTl.current = gsap.timeline({
          paused: true,
        });

        mobileMenuTl.current.to(".navbarcollapse", {
          autoAlpha: 1,
          duration: 0.18,
          ease: "power2.out",
        });

        mobileMenuTl.current.to(
          ".mobile-nav-item",
          {
            opacity: 1,
            y: 0,
            duration: 0.32,
            stagger: 0.07,
            ease: "power2.out",
          },
          "-=0.06"
        );
      }, navbarRef);

      return ctx;
    };

    let ctx = setupMobileAnimation();

    const handleResize = () => {
      const wasMobile = mobileMenuTl.current !== null;
      const isMobile = window.innerWidth < 768;

      // Only rebuild when crossing the breakpoint.
      if (wasMobile !== isMobile) {
        mobileMenuTl.current?.kill();
        mobileMenuTl.current = null;

        if (!isMobile) {
          gsap.set(".navbarcollapse", {
            clearProps: "opacity,visibility",
          });

          gsap.set(".mobile-nav-item", {
            clearProps: "opacity,transform",
          });
        }

        ctx?.revert();
        ctx = setupMobileAnimation();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      mobileMenuTl.current?.kill();
      mobileMenuTl.current = null;
      ctx?.revert();
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth < 768 && mobileMenuTl.current) {
      if (isMobileMenuOpen) {
        mobileMenuTl.current.timeScale(1).play();
      } else {
        mobileMenuTl.current.timeScale(1).reverse();
      }
    }
  }, [isMobileMenuOpen]);


  return (
    <Navbar 
      ref={navbarRef} 
      fixed="top" 
      collapseOnSelect 
      expand="md" 
      className="autobet-navbar"
      expanded={isMobileMenuOpen}
      onToggle={(expanded) => setIsMobileMenuOpen(expanded)}
      style={{
        '--nav-color': colors.secondary.contrastText,
        '--nav-hover-color': colors.primary.light,
        '--nav-font-family': typography.fontFamily,
        '--nav-font-size': typography.body1.fontSize,
        '--nav-font-weight': typography.fontWeightMedium,
      }}
    >
      <Nav className="mr-auto">
        <Nav.Link href={Path.root} className="Logo ml-sm-3 ml-0">
          <Image
            ref={logoImageRef}
            onClick={() => history.push(Path.root)}
            src={require("../../static/Images/logo.png")}
            style={{
              width: 50,
              height: 50,
              cursor: "pointer",
              marginRight: "5px",
            }}
          />
          <span style={{ marginBottom: "6px" }}>
            <div
              ref={logoTextRef}
              style={{ color: colors.slate[400], fontSize: "20px", marginBottom: 0 }}
              className="autobetLg"
            >
              <span style={{ color: colors.secondary.contrastText, fontWeight: 600, marginLeft: 0 }}>AutoBET</span>
            </div>
          </span>
        </Nav.Link>
      </Nav>
      
      <div className="d-flex align-items-center" style={{ gap: '20px' }}>
        <div className="d-block d-md-none position-relative">
          <div
            className="bell-icon"
            onClick={(e) => {
              history.push(Path.notifications);
              fetchData();
            }}
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <BellDot size={20} color={colors.secondary.contrastText} />
          </div>
        </div>

        {(user !== "" && (
          <div
            className="d-block d-md-none"
            onClick={() => history.push(Path.profile)}
            style={{ cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}
          >
            <User
              size={24}
              color={colors.secondary.contrastText}
            />
            <span style={{
              fontSize: "9px",
              fontWeight: 600,
              color: colors.secondary.contrastText,
              letterSpacing: "0.03em",
              lineHeight: 1,
              opacity: 0.85,
              whiteSpace: "nowrap",
            }}>
              {`${user.substring(0, 2)}....${user.substring(user.length - 4, user.length)}`}
            </span>
          </div>
        )) || (
          <div className="d-block d-md-none">
            <CommonButton
              onClick={() => handleConnectWallet()}
              variant="contained"
              size="small"
              sx={{ borderRadius: "8px", px: 2, py: 0.5 }}
            >
              Connect
            </CommonButton>
          </div>
        )}
        
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          className="custom-toggler border-0 shadow-none p-0"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} color={colors.secondary.contrastText} /> : <Menu size={28} color={colors.secondary.contrastText} />}
        </Navbar.Toggle>
      </div>
      <div className={`navbar-collapse collapse justify-content-end navbarcollapse ${isMobileMenuOpen ? "show" : ""}`}>
        <Nav style={{ position: "relative", alignItems: "center", gap: "1.25rem" }} onMouseLeave={() => { handleNavLeave(); }}>
          <div 
            ref={underlineRef} 
            style={{ 
              position: "absolute", 
              bottom: "0px", 
              height: "2px", 
              backgroundColor: colors.primary.light, 
              opacity: 0, 
              pointerEvents: "none", 
              zIndex: 10,
              left: 0,
              width: 0,
              borderRadius: "2px"
            }} 
          />
          <Nav.Link 
            as="div"
            className={`hovernav mobile-nav-item mobile-dropdown-trigger ${expandedMobileDropdown === 'lotteries' ? 'expanded' : ''}`} 
            onMouseEnter={(e) => {
              if (window.innerWidth >= 768) { handleNavLeave(); setIsDropdownOpen(true); }
              else { animateBgIn(e); }
            }}
            onTouchStart={(e) => { animateBgIn(e); }}
            onMouseLeave={(e) => { 
              if (window.innerWidth >= 768) setIsDropdownOpen(false); 
              else animateBgOut(e);
            }}
            onTouchEnd={(e) => { animateBgOut(e); }}
            onClick={(e) => {
              if (e.target.closest && e.target.closest('.mobile-lottery-submenu')) {
                return;
              }
              e.preventDefault();
              e.stopPropagation();
              if (window.innerWidth < 768) {
                setExpandedMobileDropdown(prev => prev === 'lotteries' ? null : 'lotteries');
              }
            }}
            style={{ position: "relative" }}
          >
            <div className="mobile-hover-bg d-md-none" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', opacity: 0, backgroundColor: colors.primary.light, pointerEvents: 'none', zIndex: 0 }} />
            <div className="nav-link-content d-flex justify-content-center align-items-center gap-2" style={{ position: 'relative', zIndex: 1, color: '#ffffff' }}>
              Explosive Lotteries
              <ChevronDown 
                size={16} 
                strokeWidth={2.5} 
                className={`dropdown-chevron ${expandedMobileDropdown === 'lotteries' ? 'rotated' : ''}`}
                style={{ marginTop: "2px", transition: 'transform 0.3s ease' }} 
              />
            </div>
            {/* Desktop dropdown — completely absent from mobile DOM via d-none */}
            <div className="d-none d-md-block">
              <CommonDropdown isVisible={isDropdownOpen} align="left">
                <CommonDropdownItem icon={<Ticket size={20}/>} title="Autobet MRL" subtitle="Main raffle lottery" to={Path.alllottery} />
                <CommonDropdownItem icon={<Dices size={20}/>} title="Autobet Revolver" subtitle="Spin and win" to={Path.Spinnerlottery} />
                <CommonDropdownItem icon={<Pickaxe size={20}/>} title="Autobet Mine" subtitle="Mine for rewards" to={Path.allminelottery} />
                <CommonDropdownItem icon={<Rocket size={20}/>} title="Autobet Missile" subtitle="Fast paced lottery" to={Path.allmissilelottery} />
              </CommonDropdown>
            </div>
            {/* Mobile-only submenu */}
            <div className={`mobile-lottery-submenu d-md-none${expandedMobileDropdown === 'lotteries' ? ' mobile-lottery-submenu--open' : ''}`} style={{ position: 'relative', zIndex: 1 }}>
              <div className="mobile-lottery-inner">
                <a href={Path.alllottery} className="mobile-lottery-item">Autobet MRL</a>
                <a href={Path.Spinnerlottery} className="mobile-lottery-item">Autobet Revolver</a>
                <a href={Path.allminelottery} className="mobile-lottery-item">Autobet Mine</a>
                <a href={Path.allmissilelottery} className="mobile-lottery-item">Autobet Missile</a>
              </div>
            </div>
          </Nav.Link>
          <Nav.Link
            onMouseEnter={(e) => { handleNavHover(e); animateBgIn(e); }}
            onTouchStart={(e) => { animateBgIn(e); }}
            onMouseLeave={(e) => { animateBgOut(e); }}
            onTouchEnd={(e) => { animateBgOut(e); }}
            className={`hovernav mobile-nav-item ${window.location.pathname.includes(Path.allgiftcards) ? "activenav" : ""}`}
            href={Path.allgiftcards}
            style={{ position: 'relative' }}
          >
            <div className="mobile-hover-bg d-md-none" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', opacity: 0, backgroundColor: colors.primary.light, pointerEvents: 'none', zIndex: 0 }} />
            <div className="nav-link-content" style={{ position: 'relative', zIndex: 1, color: '#ffffff' }}>Gift Cards</div>
          </Nav.Link>
          <Nav.Link
            onMouseEnter={(e) => { handleNavHover(e); animateBgIn(e); }}
            onTouchStart={(e) => { animateBgIn(e); }}
            onMouseLeave={(e) => { animateBgOut(e); }}
            onTouchEnd={(e) => { animateBgOut(e); }}
            className={`hovernav mobile-nav-item ${window.location.pathname.includes(Path.result) ? "activenav" : ""}`}
            href={Path.result}
            style={{ position: 'relative' }}
          >
            <div className="mobile-hover-bg d-md-none" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', opacity: 0, backgroundColor: colors.primary.light, pointerEvents: 'none', zIndex: 0 }} />
            <div className="nav-link-content" style={{ position: 'relative', zIndex: 1, color: '#ffffff' }}>Results</div>
          </Nav.Link>
          <Nav.Link
            onMouseEnter={(e) => { handleNavHover(e); animateBgIn(e); }}
            onTouchStart={(e) => { animateBgIn(e); }}
            onMouseLeave={(e) => { animateBgOut(e); }}
            onTouchEnd={(e) => { animateBgOut(e); }}
            className={`hovernav mobile-nav-item ${window.location.pathname.includes(Path.org) ? "activenav" : ""}`}
            href={Path.org}
            style={{ position: 'relative' }}
          >
            <div className="mobile-hover-bg d-md-none" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', opacity: 0, backgroundColor: colors.primary.light, pointerEvents: 'none', zIndex: 0 }} />
            <div className="nav-link-content" style={{ position: 'relative', zIndex: 1, color: '#ffffff' }}>Lottery Creator</div>
          </Nav.Link>
          <Nav.Link
            onMouseEnter={(e) => { handleNavHover(e); animateBgIn(e); }}
            onTouchStart={(e) => { animateBgIn(e); }}
            onMouseLeave={(e) => { animateBgOut(e); }}
            onTouchEnd={(e) => { animateBgOut(e); }}
            className={`hovernav mobile-nav-item ${window.location.pathname.includes(Path.news) ? "activenav" : ""}`}
            href={Path.news}
            style={{ position: 'relative' }}
          >
            <div className="mobile-hover-bg d-md-none" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', opacity: 0, backgroundColor: colors.primary.light, pointerEvents: 'none', zIndex: 0 }} />
            <div className="nav-link-content" style={{ position: 'relative', zIndex: 1, color: '#ffffff' }}>News</div>
          </Nav.Link>
          <Nav.Link
            onMouseEnter={(e) => { handleNavHover(e); animateBgIn(e); }}
            onTouchStart={(e) => { animateBgIn(e); }}
            onMouseLeave={(e) => { animateBgOut(e); }}
            onTouchEnd={(e) => { animateBgOut(e); }}
            className={`hovernav mobile-nav-item ${window.location.pathname.includes(Path.help) ? "activenav" : ""}`}
            href={Path.help}
            style={{ position: 'relative' }}
          >
            <div className="mobile-hover-bg d-md-none" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', opacity: 0, backgroundColor: colors.primary.light, pointerEvents: 'none', zIndex: 0 }} />
            <div className="nav-link-content" style={{ position: 'relative', zIndex: 1, color: '#ffffff' }}>Help</div>
          </Nav.Link>
          <Nav.Link
            onMouseEnter={(e) => { handleNavHover(e); animateBgIn(e); }}
            onTouchStart={(e) => { animateBgIn(e); }}
            onMouseLeave={(e) => { animateBgOut(e); }}
            onTouchEnd={(e) => { animateBgOut(e); }}
            className={`hovernav mobile-nav-item ${window.location.pathname.includes(Path.about) ? "activenav" : ""}`}
            href={Path.about}
            style={{ position: 'relative' }}
          >
            <div className="mobile-hover-bg d-md-none" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '0%', opacity: 0, backgroundColor: colors.primary.light, pointerEvents: 'none', zIndex: 0 }} />
            <div className="nav-link-content" style={{ position: 'relative', zIndex: 1, color: '#ffffff' }}>About Us</div>
          </Nav.Link>
          <div className="d-none d-md-block">
            <Nav.Link 
              className="hovernav d-flex"
              onMouseEnter={() => { handleNavLeave(); setIsNotifOpen(true); fetchData(); }}
              onMouseLeave={() => setIsNotifOpen(false)}
              style={{ position: "relative" }}
            >
              <div
                className="bell-icon"
                onClick={() => {
                  history.push(Path.notifications);
                  fetchData();
                }}
                style={{ display: "flex", alignItems: "center" }}
              >
                <BellDot size={18} style={{ marginBottom: "2px" }} />
              </div>
              <CommonDropdown isVisible={isNotifOpen} align="right">
                <Notification notifications={notifications} />
              </CommonDropdown>
            </Nav.Link>
          </div>

          <div className="d-none d-md-block">
            {user === "" && (
              <Nav.Link onMouseEnter={handleNavLeave} style={{ padding: "0 10px" }}>
                <CommonButton
                  onClick={() => handleConnectWallet()}
                  variant="contained"
                  size="medium"
                  sx={{ borderRadius: "8px", px: 3, py: 1 }}
                >
                  Connect
                </CommonButton>
              </Nav.Link>
            )}
          </div>
          
          <div className="d-none d-md-block">
            {user !== "" && (
              <Nav.Link href={Path.profile} className="accNAdd d-flex align-items-center hovernav" onMouseEnter={handleNavLeave} style={{ gap: "0.5rem" }}>
                <span className="AccountAddress" style={{ color: "inherit", fontSize: "inherit", fontWeight: "inherit" }}>
                  {`${user.substring(0, 2)}.... ${user.substring(
                    user.length - 4,
                    user.length
                  )}`}
                </span>
                <User
                  size={22}
                  color="currentColor"
                  style={{ cursor: "pointer" }}
                />
              </Nav.Link>
            )}
          </div>
        </Nav>
      </div>
      {/* Scroll listener for Navbar background transition could be implemented here */}
      <Modal
        className="PopupStyle"
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        onClose={() => setIsModalOpen(false)}
      >
        <Modal.Body>
          <Container>
            <Row>
              <Col lg={12}>
                <div className="message-text">{modalMessage}</div>
                <p className="link-textt" style={{ marginTop: "16px" }}>
                  <a href={Path.help} style={{ color: colors.primary.main, textDecoration: "none", fontWeight: 500 }}>
                    Get Help
                  </a>
                </p>
              </Col>
              <Col xs={12}>
                <div className="btn-div">
                  <Button
                    variant="primary"
                    className="submit-btn"
                    onClick={() => {
                      setIsModalOpen(false);
                    }}
                  >
                    OK
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
      <ToastContainer autoClose={5000} />
    </Navbar>
  );
};

export default NavBar;
